import React, { FCC } from 'react';
import { fontAwesome, Icon } from '../Icon';
import { IDropdownTriggerProps } from './types';

import { faChartPie, faEllipsisH } from '@fortawesome/pro-solid-svg-icons';
fontAwesome.library.add(faChartPie, faEllipsisH);

export const triggerEllipsis = (props: IDropdownTriggerProps) => {
  const { title, noCaret, tabIndex, ...otherprops } = props;
  return (
    // need type="button" so that this button does not trigger a form submit when inside a form
    <button type="button" {...otherprops}>
      <Icon icon={'ellipsis-h'} title="menu" />
    </button>
  );
};

export const triggerDefault = (props: IDropdownTriggerProps) => {
  const { title, noCaret = false, tabIndex, ...otherprops } = props;
  return (
    // need type="button" so that this button does not trigger a form submit when inside a form
    <button type="button" {...otherprops}>
      {title} {noCaret === false && <span className="caret" />}
    </button>
  );
};

/**
 * triggerRenderer example
 *
 * Use IDropdownTriggerProps as the props interface
 * Destructure props to ...otherprops so it does not include title, noCaret
 * Apply otherprops to the trigger container
 */
export const triggerExample = (props: IDropdownTriggerProps) => {
  const { title, noCaret = false, ...otherprops } = props;
  return (
    <div {...otherprops}>
      <Icon icon={'chart-pie'} />
      <span style={{ padding: '0 5px', margin: '0 5px', border: 'thin solid red' }}>{title}</span>
      <Icon icon={'chart-pie'} />
      {noCaret === false && <span className="caret" />}
    </div>
  );
};
